export const formatSeconds = (value) => {
    let days = parseInt(value / 86400, 10);
    let hours = parseInt(value / 3600, 10) - days * 24;
    let minutes = parseInt(value / 60, 10) - days * 24 * 60 - hours * 60;
    let seconds = parseInt(value, 10) - days * 24 * 3600 - hours * 3600 - minutes * 60;
    const date_days_left = parseInt(days / 10, 10);
    const date_days_right = parseInt(days % 10, 10);

    const date_hours_left = parseInt(hours / 10, 10);
    const date_hours_right = parseInt(hours % 10, 10);

    const date_minute_left = parseInt(minutes / 10, 10);
    const date_minute_right = parseInt(minutes % 10, 10);

    const date_second_left = parseInt(seconds / 10, 10);
    const date_second_right = parseInt(seconds % 10, 10);
    return `${date_days_left || ''}${date_days_right}天${date_hours_left || ''}${date_hours_right}时${date_minute_left || ''}${date_minute_right || ''}分${date_second_left || ''}${date_second_right}秒`;

};


export const compareVersionEle = (currVersion, targetVerison) => {
    if (!currVersion || !targetVerison) return false;
    const curr = currVersion.split('.');
    const target = targetVerison.split('.');
    for (let i = 0; i < curr.length; i++) {
        // eslint-disable-next-line radix
        if (parseInt(curr[i], 10) > parseInt(target[i], 10)) {
            return true;
        }
        // eslint-disable-next-line radix
        if (parseInt(curr[i], 10) < parseInt(target[i], 10)) {
            return false;
        }
        // 相等继续
        if (parseInt(curr[i], 10) === parseInt(target[i], 10)) {
            continue;
        }
    }
    return true;
};

export const getAndroidVersion = (ua) => {
    ua = (ua || navigator.userAgent).toLowerCase();
    let match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};
export const compareAndroid = (version) => {
    if (window.PPDWebUI && window.PPDWebUI.os.android) {
        return compareVersionEle(getAndroidVersion(), version || '6.0.0');
    }
};
export const compareIos = (version) => {
    if (window.PPDWebUI && window.PPDWebUI.os.ios) {
        return compareVersionEle(getIosVersion(), version || '10.0.0');
    }
};

export const getIosVersion = () => {
    const str = navigator.userAgent.toLowerCase();
    const ver = str.match(/cpu iphone os (.*?) like mac os/);
    return ver[1].replace(/_/g, '.');
};

export const versionCompare = () => {
    // @ts-ignore
    if (window.PPDWebUI && window.PPDWebUI.os.android) {
        return compareAndroid('6.0.0');
        // @ts-ignore
    } else if (window.PPDWebUI && window.PPDWebUI.os.ios) {
        return compareIos('10.0.0');
    } else {
        return true;
    }
};
